<template>
  <div class="wrap">
    <div class="top main_bg">
      <div class="head flex flex_start">
        <div class="left" @click="$router.push('/me/set/index')">
          <img class="userIcon" :src="userInfo.userIcon?userInfo.userIcon:default_headIcon" alt="">
        </div>
        <div class="right f16 white_f pub_left">
          <div class="flex flex_start">
            <span @click="$router.push('/me/set/index')">{{ userInfo.nickName || '请登录' }}</span>
            <span class="f10 uRole" v-if="userInfo.pca&&userInfo.pca.status==='1'">单品代理</span>
            <span class="f10 uRole" v-if="userInfo.cfm&&userInfo.cfm.status==='1'">云店铺</span>
          </div>
          <div class="flex space_between">
            <div>{{ userInfo.phone|hidetel }}</div>
          </div>
        </div>
        <div class="icon flex space_between">
          <div class="msg">
            <img src="@/assets/image/common/xiaoxi.png" mode="aspectFit" @click="$router.push('/me/message/list')">
            <span class="white main_co msgNum" v-if="userInfo.msgRead>0">{{ userInfo.msgRead }}</span>
          </div>
          <div class="set">
            <van-icon name="setting-o" color="#ffffff" size="24px" @click="$router.push('/me/set/index')"/>
          </div>
        </div>
      </div>
      <div class="bonusBox">
        <div class="flex space_between line" v-if="userInfo.bonus">
          <div class="white_f f14">
            <span>可提现余额</span>
            <span class="f24 money">{{ userInfo.bonus.balance }}</span>
          </div>
          <div class="f14" @click="$router.push('/me/withdraw/apply')" v-if="userInfo.status == '10'"
               style="line-height: 0.6rem;vertical-align:middle;border-radius: 1rem; border: 1px solid rgba(255,229,149,0.5); padding: 0 4%;color:#FFE595;">
            立即提现
          </div>
        </div>
        <div class="flex space_between line" v-if="userInfo.bonus">
          <div class="white_f f14">
            <span>平台消费券</span>
            <span class="f14 money">{{ userInfo.bonus.xfq }}</span>
          </div>
          <div class="gray_f">可用于全平台产品消费使用</div>
        </div>
        <!--自营(云店、商圈)-->
        <div class="flex space_between line" v-if="userInfo.bonus">
          <div class="left">云店</div>
          <div class="right">
            <div class="flex space_between">
              <div class="item">
                <p>{{ userInfo.bonus.ydBonus }}</p>
                <span>可提现待入账</span>
              </div>
              <div class="item">
                <p>{{ userInfo.bonus.xfqPre }}</p>
                <span>平台消费券待入账</span>
              </div>
            </div>
            <div class="tips gray_f">
              订单签收后待入账金额减少,可提现、平台消费券增加。
            </div>
          </div>
        </div>
        <!--联盟-->
        <div class="flex space_between line" v-if="userInfo.bonus">
          <div class="left">联盟</div>
          <div class="right">
            <div class="flex space_between">
              <div class="item" @click="showJS1=true">
                <p>{{ userInfo.bonus.unionTM }}</p>
                <span>本月待入账</span>
              </div>
              <div class="item" @click="showJS2=true">
                <p>{{ userInfo.bonus.unionLM }}</p>
                <span>上月待入账</span>
              </div>
            </div>
            <p class="divider"></p>
            <div class="flex space_between">
              <div class="item" style="color: #ffd880;" @click="showJS3=true">
                <p>{{ userInfo.bonus.unionTMJS }}</p>
                <span>本月待结算</span>
              </div>
              <div class="item" style="color: #ffd880;" @click="showJS4=true">
                <p>{{ userInfo.bonus.unionLMJS }}</p>
                <span>上月待结算</span>
              </div>
            </div>
            <div class="tips gray_f">
              联盟包括淘宝、天猫、京东、拼多多、饿了么等。
            </div>
          </div>
        </div>
        <!--其他-->
        <div class="flex space_between line">
          <div class="left">其他</div>
          <div class="right">
            <div class="other flex space_between" v-if="userInfo.travelFunds>0">
              <span class="item">旅游基金</span>
              <span class="item">{{ userInfo.travelFunds }}</span>
            </div>
            <div class="other flex space_between" v-if="userInfo.bpq>0">
              <span class="item">爆品购物券</span>
              <span class="item">{{ userInfo.bpq }}</span>
            </div>
            <div v-if="userInfo.bonus&&userInfo.bonus.needBack>0&&userInfo.bonus.needBack>userInfo.bonus.hasBack">
              <div class="other flex space_between">
                <span class="item">预支应回填</span>
                <span class="item">{{ userInfo.bonus.needBack }}</span>
              </div>
              <div class="other flex space_between">
                <span class="item">预支已回填</span>
                <span class="item">{{ userInfo.bonus.hasBack }}</span>
              </div>
            </div>
            <div class="other flex space_between" v-if="userInfo.bonus&&userInfo.bonus.zsq>0">
              <span class="item">代理费</span>
              <span class="item">{{ userInfo.bonus.zsq }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="imgRuleBox flex">
        <div class="item">
          <img src="@/assets/image/my/btntb.png" @click="showrule('什么是铜板',agreement+'?id=6')" mode="widthFix"/>
        </div>
        <div class="item">
          <img src="@/assets/image/my/icon_info_pca.png" @click="showrule('什么是单品代理',agreement+'?id=10')"
               mode="widthFix" style="width: 100%;height: 34px;"/>
        </div>
        <div class="item">
          <img src="@/assets/image/my/icon_info_ydp.png" @click="showrule('什么是云店铺',agreement+'?id=7')"
               mode="widthFix"/>
        </div>
      </div>

      <div class="showNumBox">
        <van-grid :column-num="3" :border="false">
          <van-grid-item @click="showhy1=true">
            <div class="num">
              <span>{{ userInfo.invNum }}</span>
              <img src="@/assets/image/my/wenhao.png" mode="widthFix" alt=""/>
            </div>
            <div class="text">邀请注册会员</div>
          </van-grid-item>
          <van-grid-item @click="showhy2=true">
            <div class="num">
              <span v-if="userInfo.pca">{{ userInfo.pca.invNum }}</span>
              <img src="@/assets/image/my/wenhao.png" mode="widthFix" alt=""/>
            </div>
            <div class="text">邀请单品代理</div>
          </van-grid-item>
          <van-grid-item @click="showhy3=true">
            <div class="num">
              <span>{{ userInfo.sumGV }}</span>
              <img src="@/assets/image/my/wenhao.png" mode="widthFix" alt=""/>
            </div>
            <div class="text">累计消费铜板</div>
          </van-grid-item>
        </van-grid>
      </div>
      <div v-if="userInfo.pca&&userInfo.pca.tips">
        <u-parse :html="userInfo.pca.tips"></u-parse>
        <!-- 解析带有样式的字符串富文本解析html样式 -->
      </div>
      <div v-if="userInfo.cfm&&userInfo.cfm.tips">
        <u-parse :html="userInfo.cfm.tips"></u-parse>
        <!-- 解析带有样式的字符串富文本解析html样式 -->
      </div>

      <!--绑定邀请人-->
      <div class="imgBtn" v-if="userInfo.invBind!=='1'" @click="showInviterOK">
        <img src="@/assets/image/my/invitecode.png" alt="" mode="widthFix"/>
      </div>
      <!--我的中心-->
      <div class="myCenter">
        <van-grid :column-num="4" :border="false">
          <van-grid-item @click="$router.push('/whyd/cart')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/gouwuche.png" alt=""/>
            <span class="text">购物车</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/order/index')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/dingdan.png" alt=""/>
            <span class="text">我的订单</span>
          </van-grid-item>
          <van-grid-item @click="toVipSys()">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/huiyuan.png" alt=""/>
            <span class="text">会员中心</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/invite')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/yaoqing.png" alt=""/>
            <span class="text">邀请</span>
          </van-grid-item>
        </van-grid>
      </div>
      <!--砍一刀-->
      <div class="imgBtn" @click="$router.push('/me/kyd/index')" v-if="userInfo.kyd&&userInfo.kyd.show=='1'">
        <img src="@/assets/image/my/kydbtn.png" alt=""/>
      </div>
      <!--申请单品代理-->
      <!-- <div class="imgBtn" @click="pushTo('/pages/my/applyPCAApply/applyPCAApply')"
        v-if="userInfo.isDisDPA=='1'">
        <img :src="imgsrcURL+'/image/my/applyDpdl.png'" alt="" style="width: 345px;" mode="widthFix" />
      </div> -->
      <!--申请店铺-->
      <!-- <div class="imgBtn" @click="pushTo('/pages/my/applyShop/applyShop')"
        v-if="userInfo.isDisCFM =='1'">
        <img :src="imgsrcURL+'/image/my/icon_apply_cfm_rank1.png'" mode="widthFix" style="width: 345px;">
      </div> -->
      <!--申请单品全国厂家总店-->
      <div class="imgBtn" @click="$router.push('/my/nfh/applyNFH')"
           v-if="userInfo.nfh&&userInfo.nfh.apply=='1'">
        <img src="@/assets/image/my/icon_apply_nfh.png" alt="" style="width: 345px;" mode="widthFix"/>
      </div>
      <!--申请代理价进货-->
      <div class="imgBtn" @click="$router.push('/whyd/ydZone?zoneType=4&zoneName=工厂价购买')"
           v-if="userInfo.rebuy&&userInfo.rebuy.show=='1'">
        <img src="@/assets/image/my/icon_rebuy.png" mode="widthFix"/>
      </div>      <!--申请购买消费券-->
      <div class="imgBtn" @click="$router.push('/me/xfq/buy')" v-if="userInfo.iconBtn&&userInfo.iconBtn.xfq=='1'">
        <img src="@/assets/image/my/icon_apply_buy_xfq.png" mode="widthFix" style="width: 345px;">
      </div>
      <div class="wohuiCenter">
        <div class="tit f16 pub_left bold_f">我惠中心</div>
        <van-grid :column-num="4" :border="false">
          <van-grid-item @click="$router.push('/me/wohui/income/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/shouruliebiao.png" alt=""/>
            <span class="text">收入列表</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/cfm/index')"
                         v-if="userInfo.cfm&&userInfo.cfm.status==='1'">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/xiaodian.png" alt=""/>
            <span class="text">我的小店</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/pca/index')"
                         v-if="userInfo.pca&&userInfo.pca.status==='1'">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/wodexiaodian.png" alt=""/>
            <span class="text">我的专卖</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/nfh/index')"
                         v-if="userInfo.nfh&&userInfo.nfh.status==='1'">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/myallshop.png" alt=""/>
            <span class="text">我的总店</span>
          </van-grid-item>

          <van-grid-item @click="$router.push('/me/wohui/reg/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/zhuceliebiao.png" alt=""/>
            <span class="text">注册列表</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/recommend/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/tuijian.png" alt=""/>
            <span class="text">推荐厂家</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/collect/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/shoucang.png" alt=""/>
            <span class="text">收藏的店</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/bankCard/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/yinhangka.png" alt=""/>
            <span class="text">银行卡管理</span>
          </van-grid-item>

          <van-grid-item @click="$router.push('/me/wohui/gift/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/giftList.png" alt=""/>
            <span class="text">赠品列表</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/prize/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/jiangpinlist.png" alt=""/>
            <span class="text">奖品列表</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/travel/list')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/lvyoulist.png" alt=""/>
            <span class="text">旅游列表</span>
          </van-grid-item>
          <van-grid-item
            @click="$router.push('/me/wohui/mentor/set?usePhone='+userInfo.mentor.myPhone+'&weChat='+userInfo.mentor.myWeChat)">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/setvx.png" alt=""/>
            <span class="text">设置微信</span>
          </van-grid-item>

          <van-grid-item
            @click="$router.push('/me/wohui/mentor/info?usePhone='+userInfo.mentor.ztPhone+'&weChat='+userInfo.mentor.ztWeChat)">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/inviter.png" alt=""/>
            <span class="text">我的导师</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/kefu/index')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/kefu.png" alt=""/>
            <span class="text">客服中心</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/help/index')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/bangzhuzhongxin.png" alt=""/>
            <span class="text">帮助中心</span>
          </van-grid-item>
          <van-grid-item @click="$router.push('/me/wohui/about/index')">
            <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/my/aboutUs.png" alt=""/>
            <span class="text">关于我们</span>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <!--底部菜单-->
    <div style="height: 60px"></div>
    <foot-bar :active="4"></foot-bar>
    <!--以下是弹窗内容-->
    <van-dialog
      v-model="showBindInv"
      title="绑定邀请人"
      show-cancel-button
      :confirm-button-color="m_color"
      confirm-button-text="确定"
      :before-close="getGUID">
      <div class="pwdbox">
        <input class="f16" v-model="invitePhone" type="number" maxlength="11" placeholder="请输入邀请人手机号">
      </div>
    </van-dialog>

    <van-popup v-model="showhy1" closeable round :style="{ width: '80%' }">
      <div class="popupBox">
        <div class="title">邀请注册会员</div>
        <div class="text">通过填写你的邀请码或者扫描您的邀请二维码成功注册成为我惠会员的总数。</div>
      </div>
    </van-popup>
    <van-popup v-model="showhy2" closeable round :style="{ width: '80%' }">
      <div class="popupBox">
        <div class="title">邀请单品代理</div>
        <div class="text">您邀请的会员申请单品代理的数量(2025.01.01起)。</div>
      </div>
    </van-popup>
    <van-popup v-model="showhy3" closeable round :style="{ width: '80%' }">
      <div class="popupBox">
        <div class="title">累计消费铜板</div>
        <div class="text">您在平台累计消费的铜板数(20230501起)。</div>
      </div>
    </van-popup>

    <van-popup v-model="showJS1" closeable round :style="{ width: '80%' }">
      <div class="popupBox">
        <div class="title">本月待入账</div>
        <div class="text">
          本月所有付款的订单所产生的预估收入（期间可能会因退款退货等原因而减少），每月1号【本月待入账】的金额自动转到【上月待入账】中，【本月待入账】的数据清零（再统计新的一个月产生的数据）。
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showJS2" closeable round :style="{ width: '80%' }">
      <div class="popupBox">
        <div class="title">上月待入账</div>
        <div class="text">
          上月所有付款的订单所产生的预估收入（期间可能会因退款退货等原因而减少），每月1号【本月待入账】的金额到【上月待入账】中。
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showJS3" closeable round :style="{ width: '80%' }">
      <div class="popupBox">
        <div class="title">本月待结算</div>
        <div class="text">
          本月所有确认收货并结算的订单（包括上个月付款并在本月确认收货的订单）产生的收入（期间可能会因为退款退货等原因而减少）。本月待结算的金额包含【本月付款后确认收货并结算的收入】和【上月付款后没有确认收货，在这个月确认收货并结算的收入】。
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showJS4" closeable round :style="{ width: '80%' }">
      <div class="popupBox">
        <div class="title">上月待结算</div>
        <div class="text">
          上月所有确认收货并结算的订单产生的收入（期间可能会因为维权等原因而减少）。每月1号【上月待结算】中的金额转到可提现余额中。
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {ForUserInfo, ForUserInfoByPhone, newbindRelation} from "../../../api/commonV2";
import user from "../../../router/user";

export default {
  name: 'index',
  computed: {
    user() {
      return user
    }
  },
  data() {
    return {
      uid: '', //会员id
      userInfo: {}, //会员基本资料
      showBindInv: false,//是否显示绑定邀请人的弹窗
      invitePhone: '',
      showhy1: false,
      showhy2: false,
      showhy3: false,
      showJS1: false,
      showJS2: false,
      showJS3: false,
      showJS4: false,
      showAgreement1: false,
      showAgreement2: false,
    }
  },
  created() {
    this.uid = localStorage.getItem('uid') || ''
    if (!this.uid) {
      this.$router.push('/user/login')
      return
    }
    //获取用户基本信息
    this.getUserInfo()
  },
  methods: {
    // 个人中心信息
    getUserInfo() {
      let data = {
        uid: this.uid
      }
      ForUserInfo(data).then(res => {
        if (res.result === '0') {
          this.userInfo = res
          localStorage.setItem('userInfo', JSON.stringify(res))
        }
      })
    },
    //会员系统
    toVipSys(item, i) {
      let sign = this.$md5(this.uid + 'WoHuiMobile' + 'SK@wohui.com-!@#123')
      // let url = '/common/rule?url=' + encodeURIComponent()
      let url=
        'https://vip.whyd365.com/Home/AppLogin?UGUID=' + this.uid +
        '&AppName=WoHuiMobile&Sign=' + sign.toUpperCase();
      // this.$router.push(url)
      window.location.href = url;
    },
    showInviterOK() {
      this.showBindInv = true
    },
    showInviterCancel() {
      this.showBindInv = false
    },
    // 根据手机号获取推荐人GUID并绑定上下级关系
    getGUID() {
      if (this.invitePhone) {
        if (this.checktel(this.invitePhone)) {
          let data = {
            phone: this.invitePhone
          }
          ForUserInfoByPhone(data).then(res => {
            if (res.result === '0') {
              this.suid = res.uid
              this.bindRelation()
            }
          })
        } else {
          this.showToast('请输入正确的邀请人手机号')
        }
      }
    },
    // 绑定上下级
    bindRelation() {
      let data = {
        uid: this.uid,
        inviteId: this.suid
      }
      newbindRelation(data).then(res => {
        if (res.result === '0') {
          this.showToast('绑定成功')
          this.showInviterCancel()
        }
      })
    },
    showrule(title, url) {
      this.$router.push('/common/rule?title=' + title + '&url=' + encodeURIComponent(url))
    }
  }
}
</script>

<style scoped lang="less">
.wrap {
  background: #F6F6F6;
}

.top {
  padding: 0 15px;
  justify-content: stretch;
  position: relative;

  .head {
    padding: 20px 0;

    .left {
      width: 20%;

      .userIcon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 8px;
      }
    }

    .right {
      width: 100%;

      .uRole {
        background: #353535;
        border-radius: 10px;
        color: #E6B26B;
        padding: 2px 5px;
        margin-left: 5px;
      }
    }

    .icon {
      width: 80px;

      .msg {
        position: relative;
        img {
          width: 24px;
          height: 24px;
        }
        .msgNum{
          display: inline-block;
          min-width: 18px;
          height: 18px; /*no*/
          line-height: 18px; /*no*/
          border-radius: 9px; /*no*/
          position: absolute;
          top: -6px; /*no*/
          right: -8px; /*no*/
          font-size: 12px; /*no*/
          transform: scale(0.85);
        }
      }
    }
  }
}

.bonusBox {
  background: #252121;
  padding: 3% 3% 0 3%;
  border-top-right-radius: .4rem;
  border-top-left-radius: .4rem;
}

.bonusBox .divider {
  width: 98%;
  border-bottom: 1px solid #403636;
  margin: .2rem auto
}

.bonusBox .money {
  color: #FFE595;
}

.bonusBox .line {
  border-bottom: 1px solid #403636;
  padding: 8px 0;
}

.bonusBox .line .left {
  color: gray;
  align-items: center;
  justify-content: center;
  writing-mode: lr-tb;
}

.bonusBox .line .right {
  width: 100%;
}

.bonusBox .line .right .other {
  height: 25px;
  line-height: 25px;
  border-bottom: 1px solid #403636;

  .item {
    color: #989898;
  }
}

.bonusBox .line .right .tips {
  width: 100%;
  font-size: .28rem;
  margin-top: 5px;
}

.bonusBox .line .right .item {
  width: 50%;
  display: inline-block;
  color: white;
}

.bonusBox .line .right .item p {
  font-size: .48rem;

}

.bonusBox .line .right .item span {
  font-size: .36rem;
}

//下半部分
.body {
  margin: 0 4%;
  /* 图片规则 铜板等*/

  .imgRuleBox {
    .item {
      width: 33.33%;

      img {
        width: 100%;
        height: 34px !important;
      }
    }
  }

  /* 9宫格 数据展示 */

  .showNumBox {
    background: #FFF;
    border-radius: 8px;
    padding: 3%;

    .num {
      height: 25px;
      line-height: 25px;
      font-size: 14px;
      color: #DDA471;

      img {
        width: 12px;
        height: 12px;
      }
    }

    .text {
      font-size: 12px;
      color: gray;
    }

    /deep/ .van-grid-item__content {
      padding: 0;
    }
  }

  /* 我的中心 购物车,我的订单等*/

  .myCenter {
    margin-top: 10px;
    background: #FFF;
    border-radius: 8px;
    padding: 3%;

    img {
      width: 50px
    }

    .text {
      font-size: 12px;
    }

    /deep/ .van-grid-item__content {
      padding: 0;
    }
  }

  /* 图片操作按钮 */

  .imgBtn {
    width: 100%;
    margin-top: 10px;

    img {
      width: 100%;
    }
  }

  .wohuiCenter {
    margin-top: 10px;
    background: #FFF;
    border-radius: 8px;
    padding: 3%;

    img {
      width: 50px;
    }

    .text {
      font-size: 12px;
    }

    /deep/ .van-grid-item__content {
      padding: 5px;
    }
  }
}

.popupBox {
  font-size: 14px;
  padding: 3%;

  .title {
    color: #E61B1B;
    height: 40px;
    line-height: 40px;
    border-bottom: #E1E1E1 solid 1px;
    font-size: 16px;
  }

  .text {
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/tabBar/me/index.vue